// Shared helpers for the standalone Calendar module.

// Brand accent (matches ConfigProvider colorPrimary in main.jsx).
export const BRAND = '#e27e56';

export const PRIORITY_COLORS = {
  Hot: '#f5222d', Warm: '#fa8c16', Cold: '#1890ff',
  Lost: '#8c8c8c', Fake: '#722ed1', Converted: '#52c41a',
};

// Base colours by event type (merged with Settings followup_type + event_type)
export const BASE_TYPE_COLORS = {
  Call: '#1890ff', Callback: '#1890ff',
  'Site Visit': '#52c41a', 'Office Visit': '#fa8c16',
  'Material Selection': '#722ed1', 'Quotation Follow-up': '#faad14',
  'Quotation Discussion': '#faad14', 'Payment Reminder': '#f5222d',
  Meeting: '#722ed1', 'Team Meeting': '#722ed1', 'Office Meeting': '#13c2c2',
  'Vendor Meeting': '#2f54eb', 'Architect Meeting': '#1890ff',
  'Personal Reminder': '#faad14', Holiday: '#f5222d', Custom: '#8c8c8c',
};

export const STATUS_COLORS = {
  Pending: 'processing', Completed: 'default', Overdue: 'error',
  Missed: 'error', Cancelled: 'default',
};

export const colorMap = (list = []) =>
  list.reduce((acc, s) => { if (s.Color) acc[s.Value] = s.Color; return acc; }, {});

// Final colour for an event: status overrides type.
export const eventColor = (ev, typeColors = BASE_TYPE_COLORS) => {
  if (ev.Status === 'Overdue' || ev.Status === 'Missed') return '#f5222d';
  if (ev.Status === 'Completed') return '#bfbfbf';
  if (ev.Status === 'Cancelled') return '#262626';
  if (ev.Color) return ev.Color;
  return typeColors[ev.EventType] || BASE_TYPE_COLORS[ev.EventType] || '#1890ff';
};
